import { pushEventDataToDataLayer } from '@homeexchange/analytics';

export const BREADCRUMB_TRACKING_AREA = 'home_view';

/**
 * Home view - Breadcrumb tracking (EX-1579)
 *
 * The breadcrumb is rendered server-side by Loc\View\Helper\AdminBreadcrumb, so each segment carries
 * its admin tier in data-breadcrumb-level (country / admin1..admin4). We read the tier rather than
 * the DOM position because the number of segments varies per listing.
 *
 * Kept in its own module so the listing-page tracking stays self-contained and depends only on the
 * analytics package, rather than on the model/API graph tracking-twig.js pulls in for its other
 * bindings.
 *
 * @param {{ isCollection: () => boolean }} [user] current user, absent for guests
 */
export const bindHomeViewBreadcrumbTracking = (user) => {
    // :not(.disabled) skips the segments the helper renders as href="#" when the admin has no
    // coordinates — they navigate nowhere, so they are deliberately not tracked.
    // Listeners are bound per segment rather than delegated on the list: the breadcrumb is
    // server-rendered and never re-rendered, so there is nothing to delegate for, and this keeps the
    // binding off Element.closest / dataset (the repo pins no browserslist floor).
    const segments = document.querySelectorAll(
        '.home-view-breadcrumb-container .breadcrumb-cities a[data-breadcrumb-level]:not(.disabled)'
    );

    for (const segment of segments) {
        segment.addEventListener('click', () => {
            pushEventDataToDataLayer('button', {
                action: 'click',
                area: BREADCRUMB_TRACKING_AREA,
                text: `breadcrumb_${segment.getAttribute('data-breadcrumb-level')}`,
                collection: !!user?.isCollection()
            });
        });
    }
};

export default bindHomeViewBreadcrumbTracking;
